import { useParams } from "react-router-dom"
import { useOrder } from "../../hooks/orders"
import { useLines } from "../../utils"
import { Container } from "@chakra-ui/react"
import OrderDetail from "../../components/Orders/OrderDetail"
import PrintMenu from "../../components/Printing/PrintMenu"
import Page from "../../components/Admin/Page"

const OrderPage = () => {
  const { orderId } = useParams()
  const { order, isLoading } = useOrder(orderId)

  const frescoLines = useLines(order, ["fresco"])
  const gastroLines = useLines(order, ["gastro", "mostarde"])

  return (
    <Page
      title={order?.orderId ? `Ordine n.${order?.orderId}` : "Ordine"}
      back={`/admin/ordini/${order?.linkId}`}
      isLoading={isLoading || order === undefined}
      toolbar={
        <PrintMenu
          linkId={order?.linkId}
          orderId={orderId}
          hasFresco={frescoLines.length > 0}
          hasGastro={gastroLines.length > 0}
        />
      }
    >
      <Container maxW="container.sm">
        {order !== undefined && (
          <OrderDetail
            order={order}
            frescoLines={frescoLines}
            gastroLines={gastroLines}
          />
        )}
      </Container>
    </Page>
  )
}

export default OrderPage
